<template>
  <div dir="rtl" class="is-flex is-align-items-center file_margin">
    <checkbox
      v-if="show_checkbox"
      @input="check"
      class="file_checkbox"
      :checked="mutable_is_checked"
    ></checkbox>
    <a
      @click="openFile"
      :class="{
        unauthorized_file: !is_authorized,
        file_error: isContainsGradesText(),
        super_hide_format: isSuperHideFormat
      }"
      target="_blank"
      class="button file_link"
      :style="{ 'font-size': font_size }"
      >{{ file.name + " " + getUploadedAt }}</a
    >
    <span
      v-if="cvTypeLabel"
      class="cv_type_badge"
      :class="'cv_type_' + cvType"
      >{{ cvTypeLabel }}</span
    >
    <div
      v-if="isContainsGradesText() || !is_authorized"
      class="faded_border_bottom"
    >
      <p class="m-0"><b>סיבות לשגיאה:</b></p>
      <p class="m-0" v-for="file_error in errors" :key="file_error">
        תו לא מקובל - "<b>{{ file_error }}</b
        >"
      </p>
      <p class="m-0" v-if="isContainsGradesText()">
        יש את המילה <b>"ציונים"</b> בשם הקובץ
      </p>
    </div>
    <div v-if="!is_profile" class="is-flex is-align-items-center">
      <a v-if="show_edit" @click="editFile" class="button is-outlined is-info" :style="{ 'font-size': font_size }">Edit</a>
      <div class="horizontal_space"></div>
      <a v-if="show_delete" @click="deleteFile" class="button is-outlined is-danger" :style="{ 'font-size': font_size }">Delete</a>
      <div class="horizontal_space"></div>
      <a v-if="show_hide" @click="hideFile" class="button is-outlined is-warning" :style="{ 'font-size': font_size }">Hide</a>
      <div class="horizontal_space"></div>
      <a v-if="show_hide" @click="superHideFile" class="button is-outlined is-dark" :style="{ 'font-size': font_size }">Super Hide</a>
      <div class="horizontal_space"></div>
      <a v-if="!isSuperHideFormat" @click="renameToSuperHide" class="button is-outlined is-success" :style="{ 'font-size': font_size }">שנה שם לסופר הייד</a>
    </div>
  </div>
</template>
<script>
import { mapMutations } from 'vuex'
import FileHelper from '@/custom/classes/file_helper.js'
import TimeHelper from '@/custom/classes/time_helper.js'
import Checkbox from '@/components/Checkbox'

// Badge wording for each FileHelper.getCvType() value. 'regular' is worded
// מקורי (and not נורמל, as the OfferExposurePreparationModal radio does)
// because here it describes the FILE — an unredacted CV — rather than a
// sending mode.
const CV_TYPE_LABELS = {
  regular: 'מקורי',
  hide: 'לייט',
  super_hide: 'סופר לייט'
}

export default {
  name: 'single-file',
  props: {
    file: {
      type: Object,
      default: () => {}
    },
    applicant: {
      type: Object,
      default: () => {}
    },
    is_checked: {
      type: Boolean,
      default: false
    },
    is_archive: {
      type: Boolean,
      default: false
    },
    show_edit: {
      type: Boolean,
      default: true
    },
    show_delete: {
      type: Boolean,
      default: true
    },
    show_hide: {
      type: Boolean,
      default: true
    },
    show_checkbox: {
      type: Boolean,
      default: true
    },
    font_size: {
      type: String
    },
    is_suitup_operation: {
      type: Boolean,
      default: false
    },
    send_mode: {
      type: String,
      default: 'normal'
    }
  },
  data () {
    return {
      is_profile: this.file.name == `פרופיל מועמד - ${this.$settings.get({ path: 'display_app_name' })} - ${this.applicant.full_name}.pdf`,
      file_helper: new FileHelper(),
      time_helper: new TimeHelper(),
      errors: [],
      is_authorized: false,
      mutable_is_checked: this.is_checked
    }
  },
  computed: {
    getUploadedAt () {
      if (this.file.uploaded_at == undefined) {
        return ''
      }
      return this.time_helper.makeTimeReadable(this.file.uploaded_at)
    },
    isSuperHideFormat () {
      return this.getSuperHideFileName(this.file.name) === this.file.name
    },
    cvType () {
      return this.file_helper.getCvType(this.file.name)
    },
    // Only CV files get a variant badge. getCvType() answers 'regular' for
    // ANY name it does not recognize, so tagging every row would stamp
    // "מקורי" on diplomas, ID scans and the generated profile PDF — files for
    // which the lite/super-lite distinction means nothing.
    isCvFile () {
      const name = (this.file.name || '').toLowerCase()
      return name.includes('cv') || name.includes('קורות')
    },
    cvTypeLabel () {
      if (!this.isCvFile) return ''
      return CV_TYPE_LABELS[this.cvType] || ''
    }
  },
  mounted () {
    this.errors = this.file_helper.getErrors(this.file.name)
    this.setIsAuthorized()
  },
  methods: {
    setIsAuthorized () {
      if (this.is_profile) {
        this.is_authorized = true
        return
      }
      this.is_authorized = this.file_helper.isAuthorized(this.file.name)
    },
    async hideFile () {
      try {
        await this.$network_utils.postEvent({
          event: 'hide_pdf_file',
          file_name: this.file.name,
          show_archive: this.is_archive,
          current_type: 'Applicant',
          current_resource_id: this.applicant.resource_id
        })
        this.$utils.emit('show_toast', { text: 'נשלח בהצלחה' })
      } catch (error) {
        this.$utils.emit('show_toast', { text: 'שגיאה' })
      }
    },
    async superHideFile () {
      try {
        await this.$network_utils.postEvent({
          event: 'hide_pdf_file',
          file_name: this.file.name,
          show_archive: this.is_archive,
          current_type: 'Applicant',
          current_resource_id: this.applicant.resource_id,
          super_hide: true
        })
        this.$utils.emit('show_toast', { text: 'Super Hide נשלח בהצלחה' })
      } catch (error) {
        this.$utils.emit('show_toast', { text: 'שגיאה' })
      }
    },
    openFile () {
      if (this.is_profile) {
        this.openProfileModal()
        return
      }
      this.$network_utils
        .getFile({
          file_name: this.file.name,
          resource_id: this.applicant.resource_id,
          resource_type: 'Applicant',
          show_archive: this.is_archive
        })
        .then(response => {
          let blob_file = new Blob([response], { type: 'application/pdf' })
          let blob_file_url = URL.createObjectURL(blob_file)
          let file_viewer_window = window.open(blob_file_url)
          setTimeout(function () {
            file_viewer_window.document.title = this.file.name
          }, 100)
        })
    },
    deleteFile () {
      this.create({
        designator: 'delete-prompt',
        component_name: 'DeletePrompt',
        modal_title: 'Delete ' + this.file.name,
        item_name: this.file.name,
        method: 'deleteFile',
        refresh: this.refresh,
        method_params: {
          file_name: this.file.name,
          resource_id: this.applicant.resource_id,
          resource_type: 'Applicant',
          first_name: this.applicant.first_name,
          last_name: this.applicant.last_name,
          show_archive: this.is_archive
        }
      })
    },
    editFile () {
      this.create({
        designator: 'file-editor',
        component_name: 'FileEditor',
        modal_title: 'Edit File - ' + this.file.name,
        file: this.file,
        applicant: this.applicant,
        refresh: this.refresh,
        is_archive: this.is_archive
      })
    },
    refresh () {
      this.$emit('refresh')
    },
    check (value) {
      this.mutable_is_checked = value
      this.$emit('input', value)
      if (this.is_profile) this.$emit('profileChecked', value)
    },
    isContainsGradesText () {
      return this.file.name.includes('ציונים')
    },
    openProfileModal () {
      this.create({
        designator: 'applicant-profile-modal',
        component_name: 'ApplicantProfilePdf',
        applicant_id: this.applicant.resource_id,
        modal_title: 'פרופיל מועמד',
        modal_width: 1000,
        is_center_modal: true
      })
    },
    getSuperHideFileName (fileName) {
      // Calculate the super hide format name based on current environment
      if (!fileName) return fileName

      const lastDotIndex = fileName.lastIndexOf('.')
      const extension = lastDotIndex === -1 ? '' : fileName.substring(lastDotIndex)

      // Get current environment from settings or default to 'rebase'
      const currentEnv = this.$settings.get({ path: 'current_environment' }) || 'rebase'

      // Generate filename in format: cv_[env].pdf
      return `cv_${currentEnv}${extension}`
    },
    async renameToSuperHide () {
      const newFileName = this.getSuperHideFileName(this.file.name)

      if (newFileName === this.file.name) {
        this.$utils.emit('show_toast', { text: 'הקובץ כבר בפורמט סופר הייד' })
        return
      }

      try {
        // Use the correct file rename endpoint with file ID
        await this.$caller.request('put', `/files/${this.file.id}`, 'admin_headers', {
          file_name: this.file.name,
          new_file_name: newFileName,
          resource_id: this.applicant.resource_id,
          resource_type: 'Applicant',
          first_name: this.applicant.first_name,
          last_name: this.applicant.last_name,
          show_archive: this.is_archive
        })

        this.$utils.emit('show_toast', { text: 'שם הקובץ שונה בהצלחה לפורמט סופר הייד' })
        this.refresh()
      } catch (error) {
        console.error('Error renaming file to super hide format:', error)
        this.$utils.emit('show_toast', { text: 'שגיאה בשינוי שם הקובץ' })
      }
    },
    ...mapMutations('modals', ['create'])
  },
  components: {
    Checkbox
  }
}
</script>

<style scoped>
.super_hide_format {
  background-color: #d4edda !important;
  border-color: #c3e6cb !important;
}
.cv_type_badge {
  margin-right: 8px;
  margin-left: 8px;
  padding: 2px 8px;
  border-radius: 10px;
  font-size: 0.7rem;
  font-weight: 700;
  white-space: nowrap;
}
/* Muted, low-contrast fills: the badge classifies the row, it must not
   out-shout the file name next to it. Green -> unredacted, orange -> lite,
   purple -> super lite (most redacted). */
.cv_type_regular {
  background-color: #e3f1e6;
  color: #2c6b40;
}
.cv_type_hide {
  background-color: #fbeedb;
  color: #8a5a13;
}
.cv_type_super_hide {
  background-color: #efe4f6;
  color: #6b2d86;
}
</style>
